import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getAllDestinations } from "../../api/Destination";
import { updateHotels } from "../../api/Hotels";
import Swal from "sweetalert2";

const options = [
  { value: "hotel1", label: "Hotel 1" },
  { value: "hotel2", label: "Hotel 2" },
  { value: "hotel3", label: "Hotel 3" },
];

const EditHotel = ({ hotel, onSuccess }) => {
  const [hotelDetails, setHotelDetails] = useState({
    id: "",
    hotel_name: "",
    email: "",
    phone_no: "",
    introduction: "",
    destination_id: "",
    address: "",
  });
  const [destinationList, setDestinationList] = useState([]);

  useEffect(() => {
    setHotelDetails({
      id: hotel?._id,
      hotel_name: hotel?.hotel_name,
      email: hotel?.email,
      phone_no: hotel?.phone_no,
      introduction: hotel?.introduction,
      destination_id: hotel?.destination_id,
      address: hotel?.address,
    });
  }, [hotel]);

  // get all destinations
  useEffect(() => {
    const getDestinationList = async () => {
      const response = await getAllDestinations();
      setDestinationList(response.destinations);
    };
    getDestinationList();
  }, []);

  const [isClearable, setIsClearable] = useState(true);
  const [isSearchable, setIsSearchable] = useState(true);

  const handleSubmit = (e) => {
    e.preventDefault();
    const response = updateHotels(hotelDetails);
    response
      .then((res) => {
        if (res.status === 200) {
          Swal.fire({
            title: "Hotel Updated!",
            text: "You have successfully updated a hotel!",
            icon: "success",
            draggable: true,
            timer: 1000,
          });
          onSuccess(res);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <form className="text-left" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="exampleInputDestination">Destination Name</label>
          <Select
            className="basic-single"
            classNamePrefix="select"
            isSearchable={isSearchable}
            options={destinationList.map((destination) => ({
              value: destination._id,
              label: destination.destination_name,
            }))}
            name="destination"
            value={destinationList
              .map((destination) => ({
                value: destination._id,
                label: destination.destination_name,
              }))
              .find((option) => option.value === hotelDetails.destination_id)} // ✅ Find by value
            onChange={(selectedOption) =>
              setHotelDetails({
                ...hotelDetails,
                id: hotelDetails?.id,
                destination_id: selectedOption.value, // ✅ Store the ID
              })
            }
          />
        </div>
        <div className="form-group">
          <label htmlFor="exampleInputName">Name</label>
          <input
            type="text"
            className="form-control"
            id="exampleInputName"
            aria-describedby="nameHelp"
            name="hotel_name"
            value={hotelDetails.hotel_name}
            onChange={(e) =>
              setHotelDetails({
                ...hotelDetails,
                id: hotelDetails?.id,
                hotel_name: e.target.value,
              })
            }
          />
        </div>
        <div className="form-group">
          <label htmlFor="exampleInputEmail1">Email</label>
          <input
            type="email"
            className="form-control"
            id="exampleInputEmail1"
            aria-describedby="emailHelp"
            name="email"
            value={hotelDetails.email}
            onChange={(e) =>
              setHotelDetails({
                ...hotelDetails,
                id: hotelDetails?.id,
                email: e.target.value,
              })
            }
          />
          <small id="emailHelp" className="form-text text-muted">
            We'll never share your email with anyone else.
          </small>
        </div>
        <div className="form-group">
          <label htmlFor="exampleInputPhone">Phone</label>
          <input
            type="phone"
            className="form-control"
            id="exampleInputPhone"
            aria-describedby="phoneHelp"
            name="phone_no"
            value={hotelDetails.phone_no}
            onChange={(e) =>
              setHotelDetails({
                ...hotelDetails,
                id: hotelDetails?.id,
                phone_no: e.target.value,
              })
            }
          />
        </div>
        <div className="form-group">
          <label htmlFor="exampleFormControlAddress">Introduction</label>
          <textarea
            className="form-control"
            id="exampleFormControlAddress"
            rows="3"
            name="introduction"
            value={hotelDetails.introduction}
            onChange={(e) =>
              setHotelDetails({
                ...hotelDetails,
                id: hotelDetails?.id,
                introduction: e.target.value,
              })
            }
          ></textarea>
        </div>
        <div className="form-group">
          <label htmlFor="exampleFormControlAddress">Address</label>
          <textarea
            className="form-control"
            id="exampleFormControlAddress"
            rows="3"
            value={hotelDetails.address}
            onChange={(e) =>
              setHotelDetails({
                ...hotelDetails,
                id: hotelDetails?.id,
                address: e.target.value,
              })
            }
          ></textarea>
        </div>
        <button type="submit" className="btn btn-primary text-right">
          Save
        </button>
      </form>
    </>
  );
};

export default EditHotel;
